// extracted by mini-css-extract-plugin
module.exports = {"field":"checkbox-field_field__2my5T","label":"checkbox-field_label__1Mh7l","active":"checkbox-field_active__T9QFw","check":"checkbox-field_check__3KJG4"};